<template lang="pug" src="./time-picker.pug"></template>

<script>
export default {
    props: {
        label: {
            type: String,
            default: 'Date'
        },
        time: {
            type: String,
            default: null
        },
        minTime: {
            type: String,
            default: null
        },
        maxTime: {
            type: String,
            default: null
        },
        errors: {
            type: String,
            default: ''
        },
        useSeconds: {
            type: Boolean,
            default: true
        }
    },
    data: () => ({
        menu: false
    }),
    methods: {
        changeTime(time) {
            this.$emit('onTimeChange', time)
        },
        closeMenu() {
            this.menu = false
        },
        onClear() {
            this.$nextTick(() => {
                this.$refs.textField.blur()
                this.$emit('onTimeChange', null)
            })
        }
    }
}
</script>
